import ReactMarkdown from 'react-markdown';
import remarkGFM from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import styled from 'styled-components';

import { wysiwyg } from './wysiwyg';

const ContentStyle = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  ${wysiwyg};
`;

const Content = ({ content }) => {
  return (
    <ContentStyle>
      <ReactMarkdown
        remarkPlugins={[[remarkGFM, remarkBreaks]]}
        unwrapDisallowed
        allowedElements={[
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'ul',
          'ol',
          'li',
          'blockquote',
          'p',
          'strong',
          'em',
          'del',
          'code',
          'img',
          'a',
        ]}
        components={{
          h1: 'h3',
          h2: 'h3',
        }}
      >
        {content}
      </ReactMarkdown>
    </ContentStyle>
  );
};

export default Content;
